export const ERRORED = 'auth/errored';
export const LOGOUT_REQUESTED = 'auth/logout_requested';
export const LOGOUT = 'auth/logout';
export const TOKEN_REQUESTED = 'auth/token_requested';
export const TOKEN_SUCCESS = 'auth/token_success';
export const USER_RIGHT_REQUESTED = 'auth/user_right_requested';
export const USER_RIGHT_LOADED = 'auth/user_right_loaded';
export const AUTH_SUCCESS = 'auth/auth_success';
